import { CampaignBody, CampaignType } from "@vviinn/user-managment-client-ts";
import { useOutletContext } from "react-router";
import { CompanyAndSiteDetails } from "../../routes/types";
import { useAppSelector } from "../../store";
import { useMemo } from "react";
import { relevantCampaignNets } from "../helpers/relevantCampaignNets";
import { setPresetValues } from "../new";

export const useCampaignDefaults = (campaignType?: CampaignType) => {
  const { siteDetails } = useOutletContext<CompanyAndSiteDetails>();

  const allowedServices = useAppSelector(
    (state) => state.company?.company?.allowedServices,
  );

  const relevantNets = useMemo(() => {
    if (!campaignType || !siteDetails) return {};
    return relevantCampaignNets(campaignType, siteDetails);
  }, [siteDetails, campaignType]);

  const defaultPresetValues: CampaignBody = useMemo(() => {
    if (!siteDetails || !campaignType) return {};
    return setPresetValues(campaignType, relevantNets);
  }, [relevantNets, campaignType, siteDetails]);

  return { allowedServices, relevantNets, defaultPresetValues };
};
